import React,{useState,useEffect} from "react";
import "./TermsAndConditions.css";
import { Link } from "react-router-dom";
const CustomerProtectionPolicy = () => {
   const [isVisible, setIsVisible] = useState(false);
    
      // Show button only after scrolling 200px
      useEffect(() => {
        const toggleVisibility = () => {
          if (window.scrollY > 200) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        };
    
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
      }, []);
    
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      };
  return (
    <div className="page-body">
    <div className="terms-container">
     {/* <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>Customer Protection Policy</strong></h5>
          <div className="breadcrumb m-0 text-end">
            <Link to="/compliance-center">Compliance Center</Link>  &nbsp;&gt;&nbsp;
            <strong>Customer Protection Policy</strong>
          </div>
        </div> */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
              <h5 className="page-title mt-3">
                <p style={{fontWeight:"600"}}>Customer Protection Policy</p>
              </h5>
            <div className="breadcrumb m-0 text-end">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
              &nbsp;&gt;&nbsp;
              <Link to="/compliance-center" className="breadcrumb-link">
                Compliance Center
              </Link>
              &nbsp;&gt;&nbsp;
              <span className="breadcrumb-current">Customer Protection Policy</span>
            </div>
            </div>

<p><strong>Customer Liability In Case Of Unauthorised Electronic Payment Transactions</strong></p>

<p><strong>&nbsp;1. </strong><strong>BACKGROUND:</strong></p>
<p>Transaction Analysts India Private Limited (TA) is committed to provide superior and safe customer service experience to all its customers. In order to enable the above, the TA has invested in technology and has robust security systems and fraud detection and prevention mechanisms in place to ensure safe and secure payment experience to its customers. Keeping in mind the increasing thrust on financial inclusion &amp; customer protection, the Reserve Bank of India had issued a circular on Customer Protection – Limiting Liability of Customers in Unauthorised Electronic Payment Transactions in Prepaid Instruments (PPIs) issued by Authorised Non-banks (RBI/2018-19/101 DPSS.CO.PD.No. 1417/02.14.006/2018-19 dated January 4, 2019) which inter-alia requires PPI to formulate a Board approved policy with &nbsp;regard to customer protection and compensation in case of unauthorized electronic payment transactions.</p>
<p><strong>2.OBJECTIVE :</strong></p>
<p>This policy seeks to communicate in a fair and transparent manner the TA’s policy on:</p>
<ol>
<li>Customer protection (including mechanism of creating customer awareness on the risks and responsibilities involved in electronic payment transactions)</li>
<li>Customer liability in cases of unauthorized electronic payment transactions</li>
<li>Customer compensation due to unauthorized electronic payment transactions (reported by customer within defined timelines)</li>
</ol>
<p><strong>3.SCOPE:</strong></p>
<p>For the purpose of this Policy, electronic payment transactions have been divided into two categories:</p>
<ol start="4">
<li>Remote / Online payment transactions (transactions that do not require physical PPIs to be presented at the point of transactions e.g. wallets, card not present (CNP) transactions, etc.).</li>
<li>Face-to-face / Proximity payment transactions (transactions which require the physical PPIs such as cards or mobile phones to be present at the point of transactions e.g. transactions at Point of Sale, etc.)</li>
</ol>
<p><strong>4. Reporting of unauthorised payment transactions by customers to PPI issuer</strong></p>
<ol>
<li>TA shall ensure that its customers mandatorily register for SMS alerts and wherever available also register for e-mail alerts, for electronic payment transactions.</li>
<li>The SMS alert for any payment transaction in the account shall mandatorily be sent to the customers and e-mail alert may additionally be sent, wherever registered. The transaction alert should have a contact number and / or e-mail id on which a customer can report unauthorised transactions or notify the objection.</li>
</ol>
<ul>
<li>Customers shall be advised to notify TA of any unauthorised electronic payment transaction at the earliest and, shall also be informed that longer the time taken to notify TA, higher will be the risk of loss to the TA / customer.</li>
</ul>
<ol>
<li>To facilitate this, TA shall provide customers with 24×7 access via website / SMS / e-mail / a dedicated toll-free helpline for reporting unauthorised transactions that have taken place and / or loss or theft of PPI.</li>
<li>Further, a direct link for lodging of complaints, with specific option to report unauthorised electronic payment transactions shall be provided by TA on mobile app / home page of its website / any other evolving acceptance mode.</li>
<li>The loss / fraud reporting system so established shall also ensure that immediate response (including auto response) is sent to the customers acknowledging the complaint along with the registered complaint number. The communication systems used by TA to send alerts and receive their responses thereto shall record time and date of delivery of the message and receipt of customer’s response, if any. This shall be important in determining the extent of a customer’s liability. On receipt of report of an unauthorised payment transaction from the customer, TA shall take immediate action to prevent further unauthorised payment transactions in the PPI.</li>
</ol>
<p><strong>5. </strong><strong>Limited liability of a customer</strong></p>
<p>A customer’s liability arising out of an unauthorised payment transaction will be limited to:</p>
<div class="table-responsive">
  <table class="responsive-table">
    <thead>
      <tr>
        <th>Sr No</th>
        <th>Particulars</th>
        <th>Maximum Liability of the Customers</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>(a)</td>
        <td>
          Contributory fraud / negligence / deficiency on the part of the PPI issuer, including PPI-MTS issuer (irrespective of whether or not the transaction is reported by the customer)
        </td>
        <td>Zero</td>
      </tr>
      <tr>
        <td>(b)</td>
        <td>
          Third party breach ** where the deficiency lies neither with the PPI issuer nor with the customer but lies elsewhere in the system, and the customer notifies the PPI issuer regarding the unauthorized payment transaction.<br/>
          The per transaction customer liability in such cases will depend on the number of days lapsed between the receipt of transaction communication by the customer from the PPI issuer and the reporting of unauthorized transaction by the customer to the PPI issuer –
        </td>
        <td></td>
      </tr>
      <tr>
        <td></td>
        <td>i. Within 3 days#</td>
        <td>Zero</td>
      </tr>
      <tr>
        <td></td>
        <td>ii. Within 4 to 7 days#</td>
        <td>Transaction value or ₹10,000/- per transaction, whichever is lower</td>
      </tr>
      <tr>
        <td></td>
        <td>iii. Beyond 7 days</td>
        <td>Full Liability</td>
      </tr>
      <tr>
        <td>(c)</td>
        <td colspan="2">
          In cases where the loss is due to negligence by a customer, such as where he / she has shared the payment credentials, the customer will bear the entire loss until he / she reports the unauthorized transaction to TA. Any loss occurring after the reporting of the unauthorized transaction shall be borne by TA.
        </td>
      </tr>
    </tbody>
  </table>
</div>



<p><strong><em># </em></strong><em>The number of days mentioned above shall be counted excluding the date of receiving the communication from the PPI issuer.</em></p>
<p><strong>**Third Party Breach :</strong></p>
<p>The following would be considered as Third party breach where deficiency lies neither with TA nor customer but elsewhere in the system:</p>
<ol>
<li>SIM duplication – Cloning of original SIM to create duplicate SIM</li>
<li>Application frauds</li>
<li>Skimming / cloning</li>
<li>External frauds / compromise of other systems, for e.g. mail servers etc. being compromised</li>
</ol>
<p><strong>6. Reversal timeline for zero liability / limited liability of a customer :</strong></p>
<p>On being notified by the customer, the TA shall credit (notional reversal) the amount involved in the unauthorised electronic payment transaction to the customer’s PPI within <strong>10 days</strong> from the date of such notification by the customer (without waiting for settlement of insurance claim, if any), even if such reversal breaches the maximum permissible limit applicable to that type / category of PPI. The credit shall be value-dated to be as of the date of the unauthorised transaction.</p>
<p>Further, TA shall ensure that a complaint is resolved and liability of the customer, if any, established within <strong>90 days</strong> from the date of receipt of the complaint, and the customer is compensated as per provisions of paragraph <strong>5 above</strong>. In case TA is unable to resolve the complaint or determine the customer liability, if any, within <strong>90 days</strong>, the amount as prescribed in paragraph 5 shall be paid to the customer, irrespective of whether the negligence is on the part of customer or otherwise.</p>
<ol start="7">
<li><strong> Burden of proof :</strong></li>
</ol>
<p>The burden of proving customer liability in case of unauthorised electronic payment transactions shall lie on the PPI issuer.<strong>&nbsp;</strong></p>
<ol start="8">
<li><strong> Reporting and monitoring requirements</strong></li>
</ol>
<p>The concerned HODs&nbsp; shall ensure that a Report&nbsp; of the customer liability cases to the Board.&nbsp; The reporting shall, inter-alia, include volume / number of cases and the aggregate value involved and distribution across various categories of cases. The Board or one of its Committees shall periodically review the unauthorised electronic payment transactions reported by customers or otherwise, as also the action taken thereon, the functioning of the grievance redressal mechanism and take appropriate measures to improve the systems and procedures.</p>
<ol start="9">
<li><strong>Other Points :</strong></li>
</ol>
<p>This policy should be read in conjunction with Customer Grievance Policy of TA. Clauses from the TA’s Customer Grievance Policy shall form a part of this policy where not specifically addressed in this policy.</p>

       {/* Add Button (aligned to left) */}
 {isVisible && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            <i className="bi bi-chevron-up"></i>
          </button>
        )}
  
  </div>
  </div>
  );
};

export default CustomerProtectionPolicy;
